import * as y from 'yup'

import { NAME_PATTERN, NON_SPACE_STRING_PATTERN } from '@src/constants/ShippableCheckoutFormSchema'
import {
  MIN_8_MAX_20_CHARS,
  NO_BANNED_CHARS,
  ONE_LOWER,
  ONE_NUMBER,
  ONE_UPPER,
} from '@src/constants/SignUpSchema'

export const nameSchema = y.object({
  firstName: y
    .string()
    .required('firstName.required')
    .matches(NON_SPACE_STRING_PATTERN, 'firstName.invalid')
    .matches(NAME_PATTERN, 'firstName.invalid')
    .max(30, 'firstName.invalid'),
  lastName: y
    .string()
    .required('lastName.required')
    .max(30, 'lastName.invalid')
    .matches(NON_SPACE_STRING_PATTERN, 'lastName.invalid')
    .matches(NAME_PATTERN, 'lastName.invalid'),
})

export const passwordSchema = y.object({
  currentPassword: y.string().required('currentPassword.required'),
  newPassword: y
    .string()
    .required('password.invalid')
    .matches(MIN_8_MAX_20_CHARS, 'password.invalid')
    .matches(ONE_UPPER, 'password.invalid')
    .matches(ONE_LOWER, 'password.invalid')
    .matches(ONE_NUMBER, 'password.invalid')
    .matches(NO_BANNED_CHARS, 'password.invalid')
    .test('notSameAsCurrentPassword', 'password.reused', function (value) {
      if (this.parent.currentPassword && value) {
        return this.parent.currentPassword !== value
      }
      return true
    }),
  confirmPassword: y
    .string()
    .required()
    .test('passwordsMustMatch', 'password.mustMatch', function (value) {
      if (this.parent.newPassword) {
        return this.parent.newPassword === value
      }
      return true
    }),
})

export const languageSchema = y.object({
  country: y.string().required(),
  lang: y.string().required(),
})

export type PasswordSchema = y.InferType<typeof passwordSchema>
export type NameSchema = y.InferType<typeof nameSchema>
export type LanguageSchema = y.InferType<typeof languageSchema>
